/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { ROUTES, setElementHeights } from '../../assets/constants/strings';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import HeaderBar from '../../components/HeaderBar';
import $ from 'jquery';
import Bookmarks from '../../components/Bookmarks';
import RightNav from '../../components/RightNav';
import Menu from '../../components/Menu';
import FAQModal from '../../components/Modals/FAQ';
import { getBookmarks } from '../../store/User/userActions';

const BookmarksPage = ({ user, bookmarks, getBookmarks }) => {
  useEffect(() => {
    $(window).on('resize', setElementHeights);

    if (user && user.isActive && !bookmarks) getBookmarks();

    document.title = 'My Bookmarks | RegulationCity';
  }, []);

  const [isRightNavVisible, setIsRightNavVisible] = useState(
    window.innerWidth > 950
  );
  const [FAQuestion, setFAQuestion] = useState(0);

  useEffect(() => {
    setElementHeights();
  });

  const handleRightNav = (visible) => {
    setIsRightNavVisible(visible);
  };

  const handleSetFAQ = (question) => {
    setFAQuestion(question);
    $('#FAQModal').modal('show');
    $('.modal-backdrop').appendTo('#wf-doc-page');
  };

  if (
    !user ||
    (user && !user.isActive)
    // (user &&
    //   !(user.accountStatus === 'trialing' || user.accountStatus === 'active'))
  ) {
    return <Redirect to={ROUTES.LOGIN} />;
  }

  return (
    <div className='wf-doc-wrapper w-100' id='wf-doc-page'>
      <nav id='sticky-top-wrapper' className='navbar sticky-top p-0'>
        <div className='w-100 d-flex flex-column '>
          <Header />
          <HeaderBar pageTitle='My Bookmarks' />
        </div>
      </nav>

      <main role='main' className='wf-document px-0 mb-0' id='wf-bookmarks'>
        <Bookmarks />
        <RightNav
          accountPage
          handleVisibility={handleRightNav}
          handleSetFAQ={handleSetFAQ}
        />

        {!isRightNavVisible && <Menu accountPage handleSetFAQ={handleSetFAQ} />}
      </main>
      <Footer isDocument isCentered isAbsolute showLogo />
      <FAQModal question={FAQuestion} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  bookmarks: state.user.bookmarks,
});

const mapDispatchToProps = { getBookmarks };

export default connect(mapStateToProps, mapDispatchToProps)(BookmarksPage);
